import React from 'react';
import './SignOutBtn.css';

class SignOutBtn extends React.Component {
    signout() {
    	window.location.replace('/logout')
    }

    render() {
    	return (
		  <button className="SignOutBtn" type="button" onClick={this.signout.bind(this)}>
		    Sign Out
		  </button>
		)
    }
}

export default SignOutBtn;
